module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/stepper_down_purple@2x.png?1.0.17";